import Pagination from '@/components/pagination';
import ManageServices from '@/components/services/manage-services';
import SiteWrapper from '@/components/siteWrapper';
import Skeleton from '@/components/skeleton';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import api from '@/lib/api';
import usePagination from '@/lib/hooks/usePagination';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

const PAGE_SIZE = 15;

const MEDIA_PLACEMENT_ID = process.env.NEXT_PUBLIC_MEDIA_PLACEMENT_ID;

const ServicesPage = ({ siteData }) => {
  const [selectedTag, setSelectedTag] = useState(null);
  const { page, handlePageChange } = usePagination();

  // const form = useForm({ defaultValues: { tags: [] } });
  // const selectedTags = form.watch('tags');

  const { data, isLoading } = useQuery({
    queryKey: [
      'services',
      {
        categoryId: MEDIA_PLACEMENT_ID,
        tagId: selectedTag,
        page,
        pageSize: PAGE_SIZE,
      },
    ],
    queryFn: () =>
      api.services
        .getAll({
          categoryId: MEDIA_PLACEMENT_ID,
          tagId: selectedTag,
          pageNumber: page,
          pageSize: PAGE_SIZE,
        })
        .then((res) => res.data),
  });

  // const { data: serviceCategories } = useQuery({
  //   queryKey: ['service-categories'],
  //   queryFn: () => api.serviceCategories.getAll().then((res) => res.data),
  // });

  const { data: subCategories } = useQuery({
    queryKey: ['service-sub-categories', { categoryId: MEDIA_PLACEMENT_ID }],
    queryFn: () =>
      api.serviceSubCategories
        .getByCategoryId(MEDIA_PLACEMENT_ID)
        .then((res) => res.data),
    enabled: !!MEDIA_PLACEMENT_ID,
  });

  return (
    <SiteWrapper siteData={siteData}>
      <div className="min-h-full py-12 px-4 sm:px-6 lg:px-8 h-full max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-4 gap-y-8">
          <div className="lg:border-r border-neutral-200 pr-6 mr-6">
            <h2 className="text-4xl text-gray-900 font-bold">Services</h2>
            <p className="mt-3 mb-8 text-neutral-800">
              Discover our range of services here
            </p>
            <div>
              <p className="text-lg font-bold">Categories</p>
              {subCategories?.length > 0 && (
                <div className="space-y-4 mt-4">
                  <RadioGroup
                    defaultValue={null}
                    onValueChange={(value) => setSelectedTag(value)}
                    className="text-sm"
                  >
                    <div className="flex items-center space-x-2">
                      <RadioGroupItem value={null} id={0} />
                      <label htmlFor={0}>All</label>
                    </div>
                    {subCategories?.map((category) => (
                      <div
                        className="flex items-center space-x-2"
                        key={category?.id}
                      >
                        <RadioGroupItem
                          value={category?.id}
                          id={category?.id}
                        />
                        <label htmlFor={category?.id}>{category?.name}</label>
                      </div>
                    ))}
                  </RadioGroup>
                </div>
              )}
            </div>

            {/* <div>
              {subCategories?.length > 0 && (
                <>
                  <p className="mb-4 mt-8 font-semibold text-sm">Tags</p>
                  <div className="space-y-2">
                    {subCategories?.map((category) => (
                      <Controller
                        key={`tag-${category.id}`}
                        name="tags"
                        control={form.control}
                        render={({ field }) => (
                          <>
                            <div className="flex items-center gap-x-2">
                              <Checkbox
                                className="bg-white"
                                id={`tag-${category.id}`}
                                checked={field.value?.includes(category.id)}
                                onCheckedChange={(checked) => {
                                  return checked
                                    ? field.onChange([
                                        ...field.value,
                                        category.id,
                                      ])
                                    : field.onChange(
                                        field.value?.filter(
                                          (value) => value !== category.id
                                        )
                                      );
                                }}
                              />
                              <label
                                htmlFor={`tag-${category.id}`}
                                className="text-sm"
                              >
                                {category?.name}
                              </label>
                            </div>
                          </>
                        )}
                      />
                    ))}
                  </div>
                </>
              )}
            </div> */}
          </div>
          <div className="lg:col-span-3 flex flex-col gap-y-3">
            {isLoading ? (
              <>
                {Array.from({ length: 5 }).map((_, idx) => (
                  <Skeleton key={idx} className="w-full h-80 rounded-xl" />
                ))}
              </>
            ) : (
              <>
                <ManageServices data={data?.data} />

                <Pagination
                  currentPage={page}
                  totalPages={data?.meta?.pagination?.pageCount}
                  setCurrentPage={handlePageChange}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </SiteWrapper>
  );
};

export async function getStaticPaths() {
  const siteData = await api.sites.find({});
  const sites = siteData?.data?.data;

  const allPaths = sites.reduce(function (result, site) {
    const subdomain = site.attributes.subdomain;
    const customDomain = site.attributes.customDomain;
    if (subdomain) {
      result.push({
        params: { site: subdomain },
      });
    }
    if (customDomain) {
      result.push({
        params: { site: customDomain },
      });
    }
    return result;
  }, []);

  return {
    paths: allPaths,
    fallback: true,
  };
}

export async function getStaticProps(context) {
  const { params, req } = context;
  const { site } = params;

  let siteData;
  if (site.includes('.')) {
    siteData = await api.sites.get({ customDomain: site });
  } else {
    siteData = await api.sites.get({ subdomain: site });
  }

  return {
    props: {
      siteData,
    },
  };
}

export default ServicesPage;
